import React, { useContext } from "react";
import DialogBox from "../CommonComponent/DialogBox";
import DynamicHtml from "../CommonComponent/DynamicHtml";
import { Card } from "@mui/material";
import { ConfigurationContext } from "../../../contexts/Configuration";
import { SearchContext } from "../../../contexts/Search";
import { CommonService } from "@services";

const PrescriberCustomNoteDialog = ({
  isOpen,
  onClose,
  noteDetails,
  resultname,
  channelName
}) => {
  const { appliedConfiguration } = useContext(ConfigurationContext);
  const { benefitType } = useContext(SearchContext);
  const benefitTypeId = benefitType == "Pharmacy" ? 2 : 1;
  const headerFooter = appliedConfiguration.coverageFinderPrescriberNoteHeaderFooters.filter(
    (obj) => obj.benefitTypeId === benefitTypeId
  )[0];
  return (
    <DialogBox isOpen={isOpen} onClose={onClose}>
      {
        <div className="norstella-cf-prescriberCustomNoteDialog" part="cfDivPrescriberCustomNoteDialog">
          {headerFooter && headerFooter.header && headerFooter.header.trim() !== "" && (
            <DynamicHtml
              input={headerFooter.header}
              resultname={resultname}
              channelName={channelName}
              className="norstella-cf-prescriberCustomNoteHeader"
              part="cfPrescriberCustomNoteHeader"
            />
          )}
          <Card className="norstella-cf-prescriberNoteCardContent" part="cfPrescriberNoteCardContent">
            <div part="cfNotedetails" className="norstella-cf-notedetails" dangerouslySetInnerHTML={{ __html: CommonService.sanitizeHTML(noteDetails) }}></div>
          </Card>
        </div>
      }
    </DialogBox>
  );
};

export default PrescriberCustomNoteDialog;
